Add a section with standard vertical space around a block It also handles #
linking

<template>
  <div
    :id="blok.sectionLinkId || blok._uid"
    class="section-wrapper"
    tabindex="-1"
  >
    <component :is="isSection ? 'section' : 'div'" class="relative">
      <div class="antialiased" :class="paddingClass">
        <slot />
      </div>
      <!-- We are not using this arrow for now -->
      <!-- <div v-if="appendArrow" class="absolute flex justify-center w-full">
      <div
        class="arrow-down-white"
        :class="{
          'arrow-down-gray-200': bgVariant === 'gray'
        }"
      ></div>
    </div> -->
    </component>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  isSection: {
    type: Boolean,
    default: true,
  },
  padding: {
    type: String,
    default: null,
    validator: (value) => ['none', 'sm', 'md', 'lg', 'xl'].includes(value),
  },
})

const paddingClass = computed(() => {
  const paddingMode = props.blok.verticalPadding || props.padding

  if (paddingMode === 'none') {
    return ''
  }
  if (paddingMode === 'sm') {
    return 'py-3 md:py-4 lg:py-5 xl:py-7'
  }
  if (paddingMode === 'md') {
    return 'py-7 md:py-8 lg:py-10 xl:py-14'
  }
  if (paddingMode === 'lg') {
    return 'py-14 md:py-16 lg:py-20 xl:py-28'
  }
  if (paddingMode === 'xl') {
    return 'py-28 md:py-32 lg:py-40 xl:py-56'
  }

  return 'py-14 md:py-16 lg:py-20 xl:py-28'
})
</script>
